export default {
  "content": "<mask id=\"a\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><path fill=\"#D9D9D9\" d=\"M0 0h20v20H0z\"/></mask><g mask=\"url(#a)\"><path d=\"M16.5 8V5.5H14V4h2.5c.417 0 .77.147 1.063.44.291.294.437.647.437 1.06V8h-1.5zM2 8V5.5c0-.417.147-.77.44-1.063A1.45 1.45 0 013.5 4H6v1.5H3.5V8H2zm12 8v-1.5h2.5V12H18v2.5c0 .417-.147.77-.44 1.063A1.45 1.45 0 0116.5 16H14zM3.5 16c-.417 0-.77-.147-1.063-.44A1.45 1.45 0 012 14.5V12h1.5v2.5H6V16H3.5zM5 13V7h10v6H5zm1.5-1.5h7v-3h-7v3z\" fill=\"currentColor\"/></g>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};